import SuiBox from "components/SuiBox";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import SubOrganizationDetails from "../components/sub-organization-details";

const EditSubOrganization = ({ subOrganization, redirectTo }) => {
  const history = useHistory();

  useEffect(() => {
    if (redirectTo && redirectTo !== "" && redirectTo !== "/suborganization/edit") {
      history.push(redirectTo);
    }
  }, [redirectTo]);

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <SubOrganizationDetails subOrganization={subOrganization} />
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

EditSubOrganization.defaultProps = {
  subOrganization: null,
  redirectTo: "",
};

EditSubOrganization.propTypes = {
  subOrganization: PropTypes.objectOf(PropTypes.any),
  redirectTo: PropTypes.string,
};

const mapStateToProps = (state, { location }) => {
  const targetId = location.state?.subOrganizationId;
  const allSubOrganizations = Array.isArray(state?.data?.subOrganizations)
    ? state?.data?.subOrganizations
    : [];
  const foundSubOrganization = allSubOrganizations.find(
    (subOrganization) => subOrganization.id === targetId
  );

  return {
    subOrganization: foundSubOrganization,
    redirectTo: state.ui.redirectTo,
  };
};

export default connect(mapStateToProps, null)(EditSubOrganization);
